import { Howl } from "howler";

export class SoundManager {
  private static instance: SoundManager;
  private sounds: Map<string, Howl> = new Map();
  private victoryIndex: number = 0;
  private enabled: boolean = true;

  private constructor() {
    const saved = localStorage.getItem("jigsaw_sound_muted");
    if (saved === "true") {
      this.enabled = false;
    }
    this.preload();
  }

  public static getInstance(): SoundManager {
    if (!SoundManager.instance) {
      SoundManager.instance = new SoundManager();
    }
    return SoundManager.instance;
  }

  private preload(): void {
    const soundConfigs: Record<
      string,
      { src: string; volume?: number; rate?: number }
    > = {
      pickup: { src: "/sounds/pickup.mp3", volume: 0.15 },
      connect: { src: "/sounds/connect.mp3", volume: 0.7, rate: 1.35 },
      coin: { src: "/sounds/coin.mp3", volume: 0.5 },
      "victory-f": { src: "/sounds/victory-f.mp3", volume: 0.4 },
      "victory-g": { src: "/sounds/victory-g.mp3", volume: 0.4 },
      "victory-a": { src: "/sounds/victory-a.mp3", volume: 0.4 },
    };

    for (const [name, config] of Object.entries(soundConfigs)) {
      const howl = new Howl({
        src: [config.src],
        volume: config.volume ?? 0.5,
        rate: config.rate ?? 1.0,
        preload: true,
      });
      this.sounds.set(name, howl);
    }
  }

  public play(name: string): void {
    if (!this.enabled) return;

    // Cycle through victory sounds
    if (name === "victory") {
      const keys = ["victory-f", "victory-g", "victory-a"];
      name = keys[this.victoryIndex];
      this.victoryIndex = (this.victoryIndex + 1) % keys.length;
    }

    const sound = this.sounds.get(name);
    if (sound) {
      sound.play();
    }
  }

  public setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  public isEnabled(): boolean {
    return this.enabled;
  }

  public setMuted(muted: boolean): void {
    this.enabled = !muted;
    localStorage.setItem("jigsaw_sound_muted", muted ? "true" : "false");
  }

  public isMuted(): boolean {
    const saved = localStorage.getItem("jigsaw_sound_muted");
    if (saved === "true") {
      this.enabled = false;
      return true;
    }
    return !this.enabled;
  }
}
